'use strict';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import Urls from '../../../definitions/Urls';

import Loader from '../../Loader';
import OTButton from '../../tag/OTButton';
import OTButtonGroup from '../../tag/OTButtonGroup';
import WindowUtils from '../../../utils/WindowUtils';

const { id: module_id } = module;

class AgreementPage1 extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    document.getElementById('skip-to-content').focus();
  }

  cancel = (event) => {
    event.preventDefault();
    this.props.triggerCancelModal();
  };

  next = () => {
    WindowUtils.navigate('#/2');
  };

  render() {
    let { userInfo } = this.props;
    return (
      <div className="ot-agreement-page">
        {userInfo && (
          <div>
            <h1 className="ot-agreement-title">
              <FormattedMessage id={`${module_id}.title`} />
            </h1>
            <br />
            <div className="row-fluid">
              <div className="span6 infotext">
                <p>
                  <b>
                    <FormattedMessage id={`${module_id}.infotext1`} />
                  </b>
                </p>
                <p>
                  <FormattedMessage id={`${module_id}.infotext2`} />
                </p>
                <p>
                  <i className="icon-edit" />{' '}
                  <a href={Urls.registerDescription} target="_blank">
                    <FormattedMessage id={`${module_id}.registerDescription`} />
                  </a>
                </p>
              </div>
              {/* Fields are not editable in any case, so we are not making these into fields*/}
              <div className="span6 ot-agreement-form">
                <div className="control-group">
                  <label
                    htmlFor={'hetu'}
                    className="control-label"
                    aria-disabled="true"
                  >
                    <span className="label_text">
                      <FormattedMessage id={'social.security.number'} />
                    </span>
                    <div className="controls">
                      <input
                        id="hetu"
                        disabled
                        className={'inactive-input'}
                        value={userInfo.hetu}
                      />
                    </div>
                  </label>
                </div>

                <div className="control-group">
                  <label
                    htmlFor="name"
                    className="control-label"
                    aria-disabled="true"
                  >
                    <span className="label_text">
                      <FormattedMessage id={'name'} />
                    </span>
                    <div className="controls">
                      <input
                        id="name"
                        disabled
                        className={'inactive-input'}
                        value={userInfo.name}
                      />
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div className="ot-agreement-buttons row-fluid text-center">
              <OTButtonGroup fullWidth type={'big'} expectedCount={2}>
                <OTButton onClick={this.cancel}>
                  <FormattedMessage id={'abort'} />
                </OTButton>
                <OTButton onClick={this.next}>
                  <FormattedMessage id={'continue'} />
                </OTButton>
              </OTButtonGroup>
            </div>
          </div>
        )}
        {!this.props.userInfo && <Loader />}
      </div>
    );
  }
}

export default AgreementPage1;
